import React from 'react';
import RMButton from '../customComponents/Controls/RMButton';
import { IStyle } from 'Styles';
import { FmlxButton } from 'fmlx-common-ui';

interface Props {
  saveDisabled?: boolean;
  onSaveClick: () => void;
  onDiscardClick?: () => void;
  saveText?: string;
  discardText?: string;
}

const formActionButon = (props: Props) => {
  const {
    saveDisabled,
    onDiscardClick,
    onSaveClick,
    discardText = 'Cancel',
    saveText = 'save',
  } = props;

  return (
    <div id='form-action-button-root' style={styles.root}>
      <RMButton
        disabled={saveDisabled}
        customStyle={{ ...styles.save, ...(!onDiscardClick ? styles.width100 : {}) }}
        onClick={onSaveClick}
        label={saveText}
        type={FmlxButton.Type.POSITIVE}
      ></RMButton>
      {onDiscardClick && (
        <RMButton
          className="btn-outline-yellow"
          onClick={onDiscardClick}
          customStyle={styles.discard}
          label={discardText}
          variant={FmlxButton.Variant.OUTLINE}
        ></RMButton>
      )}
    </div>
  );
};

const styles: IStyle = {
  root: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 10,
  },
  save: {
    backgroundColor: '#F7A246',
    width: '5.5rem',
  },
  discard: {
    width: '5.5rem',
  },
  width100: {
    width: '100%',
  },
};

export default formActionButon;
